
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorDeCurso } from '../../controlador-detalles';
    import { Curso, Participante } from '@/__env/lib/Cursos';

    @Component( {
        name: "Componente",
        props: {},
        components: {

        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador(): ControladorDeCurso { return Model; }
        public get Curso(): Curso { return this.Controlador.Curso; }

        public Estado: string = 'cargando';

        public Seleccionado: Participante = null;
        @Watch( 'Seleccionado' )
        onSeleccionado()
        {
            this.Controlador.Seleccionado = null;
            this.$nextTick( () =>
            {
                this.Controlador.Seleccionado = this.Seleccionado;
            } );

        }

        protected Eventos: Function[] = [];
        beforeDestroy() { this.Eventos.forEach( x => x() ); }
        async mounted()
        {
            this.Estado = this.Controlador.Vista.Estado;
            this.Eventos.push( this.Controlador.Vista.onEstado.subscribe( () => this.Estado = this.Controlador.Vista.Estado ) );

        }


    }
